"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverlayManager = void 0;
var React = __importStar(require("react"));
var common_1 = require("../../common");
var OverlayManager = function (_a) {
    var children = _a.children;
    var _b = React.useState(null), element = _b[0], setElement = _b[1];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var callbackRef = React.useCallback(setElement, []);
    return (React.createElement(common_1.OverlayContext.Provider, { value: { overlay: element } },
        React.createElement("div", { "data-qa": "gk-overlay-container", className: "gk-overlay", ref: callbackRef }),
        children));
};
exports.OverlayManager = OverlayManager;
exports.default = exports.OverlayManager;
